import React, { useEffect, useState } from 'react';
import Table from '../controls/table';
import ConformationPopup from '../controls/conformationPopup';
import { useDispatch, useSelector } from "react-redux";
import { AppToast } from '../../lib/toast';
import { RenderIcons } from '../controls/icons';
import { deleteDataListing, upsertDataListing } from '../../store/listing/listingSlice';
import { UpdateListItemPopup } from './updateListItemPopup';
import { getTemplate } from '../../store/template/templateSlice';
import { setButtonsData } from '../../store/banner/bannerSlice';
import { deletePopUpIcon, svg } from '../../common/labelConstants';
import { encryptData, getConfiguredLabel } from '../../common/commonHelper';
import { usePermissions } from '../../hooks/usePermissions';
import { setChartDataEditted } from '../../store/charts/chartSlice';
import { updateDocumentUpload } from '../upload/uploadHelper';
import { VersionListingPopup } from './versionListingPopup';

const _pageActionsInfo = {
    add: { title: 'Add', message: '', actions: { ok: { label: 'Add' }, cancel: { label: 'Cancel' } } },
    edit: { title: 'Edit', message: '', actions: { ok: { label: 'Save' }, cancel: { label: 'Cancel' } } },
    delete: {
        title: 'Confirm Deletion', message:
            <span className='deletePopUp'>
                <span className='mr-3'>
                    <span dangerouslySetInnerHTML={{ __html: getConfiguredLabel(svg, deletePopUpIcon) }}></span>

                </span>
                {'Are you sure you want to delete this item?'}
            </span>, actions: { ok: { label: 'Yes, Delete' }, cancel: { label: 'Cancel' } }
    },

}

const _action = { title: '', message: '', actions: { ok: { label: '' }, cancel: { label: '' } } }

const _props = {
    dataType_id: '',
    templateName: '',
    editDataTemplateName: '',
    rowClass: () => { },
    handleDownload: (selectedRows, setSelectedRows) => { },
    handleDelete: (rows, refreshData_fn, showDeletePopup) => { },
    renderHeaderAreaRight: ({ btn_download = <></>, btn_delete = <></>, filter_global = <></>, orderBy_icon = <></>, sortBy_dropdown = <></>, add_item = (btnJsx = <></>) => { return <></> }, selectedRows = [], setSelectedRows = (rows = []) => { } }) => { return <></> },
    renderHeaderAreaLeft: ({ pagingInfo = <></>, specialInfo = <></> }) => { },
    pageActionsInfo: _pageActionsInfo,
    testActionAgainstData: { edit: (row) => { return true }, delete: (row) => { return true }, passwordReset: (row)=>{ return true} },
    handlePasswordReset : (row) => {},
    paginator:true
}
function DataListing(props = _props) {
    const permissions = usePermissions();

    const pageActionsInfo = props.pageActionsInfo || _pageActionsInfo
    const dispatch = useDispatch();
    const checkButton = useSelector(state => state.banner.buttons)
    let refreshChart = useSelector( x => x.chart.isDataEditted)
    const [rowData, setRowData] = useState({});
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [table_methods, setTable_methods] = useState({});
    const [rowsToBeDeleted, setRowsToBeDeleted] = useState([])
    const [isMounted, setIsMounted] = useState(true);
    const [controls, setControls] = useState([])
    const [templateActions, setTemplateActions] = useState({ width: '', items: [] })
    const [currentActionInfo, setCurrentActionInfo] = useState(_action)
    const [manageAddToast, setManageAddToast] = useState(false)
    const [pagingDropDownInfo,setPagingDropDownInfo]= useState([])
    const [defaultPagingValue,setDefaultPagingValue] = useState([])
    const [showVersionListingPopup,setShowVersionListingPopup] = useState(false)
    const slbSearchConfig = window.slbConfig || {};

    useEffect(() => {
        let data = {
            clientId: slbSearchConfig.accountId,
            templateName: props.templateName,
            dataType_id: props.dataType_id
        }
        dispatch(getTemplate(data)).then((res) => {
            if (isMounted && res.payload.status === 200) {
                const serverResp = res.payload.data || {}
                if (typeof serverResp === 'object') {
                    setControls(serverResp.data)
                    setTemplateActions(serverResp.actions)
                    setPagingDropDownInfo(serverResp.pageSizeSetting?.dropDownPagingOption || [10,20,50])
                    setDefaultPagingValue(serverResp.pageSizeSetting?.defaultPageSize || serverResp.pageSizeSetting?.dropDownPagingOption[0] || 10)
                }
            }
        })
        return () => {
            setIsMounted(false)
        }
    }, [])

    useEffect(() => {
        if (checkButton) {
            handleAddNewItem();
            setManageAddToast(true)
        }
        dispatch(setButtonsData(false))
    }, [checkButton])

    const handleDelete = (rows) => {
        const reqBody = {
            dataType_id: props.dataType_id,
            rows: rows
        }
        dispatch(deleteDataListing(reqBody)).then((res) => {
            if (res.payload.status === 200) {
                AppToast.Toast.success({ title: props?.actionToaster?.delete?.title, message: props?.actionToaster?.delete?.message })
                table_methods.refresh()
                table_methods.setSelectedRows([])
                setRowsToBeDeleted([])
            }
            else if (res.payload.status === 555) {
                AppToast.Toast.error({ title: props?.actionToaster?.delete?.title, message: props?.actionToaster?.delete?.deleteNotAllowedMessage})
            }
        })
        setRowData({});
        setShowDeletePopup(false)
    }

    const handleActions = (rowData, action, event) => {
        setRowData(rowData)
        switch (action) {
            case 'edit': {
                setShowEditPopup(true)
                setCurrentActionInfo(pageActionsInfo.edit)
                setManageAddToast(false)
            }
                break;
            case 'delete': {
                setShowDeletePopup(true);
                setRowsToBeDeleted([rowData])
                setCurrentActionInfo(pageActionsInfo.delete)
            }
                break;
            case 'download': {
                if (typeof props.handleDownload === 'function') {
                    props.handleDownload([rowData], table_methods.setSelectedRows)
                }
            }
            case 'passwordReset': {
                if (typeof props.handlePasswordReset === 'function') {
                    props.handlePasswordReset(rowData)
                }
            }
            default:
                break;
        }
        event.stopPropagation()
    }

    
    
    const handleAddNewItem = () => {
        setRowData({});
        setShowEditPopup(true);
        setCurrentActionInfo(pageActionsInfo.add)
    }

    const handleEditData = (edit_data) => {
        let rowEdittedData = { ...rowData, ...edit_data, dataType_id: props.dataType_id };
        if((rowEdittedData.authType?.val || '').toLowerCase() =="form"){ //encrypting the credentials during add user
            rowEdittedData={...rowEdittedData, userPassword:rowEdittedData.userPassword,//encryptData(rowEdittedData.userPassword),
                emailId:rowEdittedData.emailId}//encryptData(rowEdittedData.emailId)
        }
        if(rowEdittedData.updateDoc){
            updateDocumentUpload(rowData, rowEdittedData, dispatch);
            rowEdittedData = {_id:rowEdittedData._id, dataType_id:rowEdittedData.dataType_id, isLatest:false, isActive: false, isArchived: false}
        }
        dispatch(upsertDataListing(rowEdittedData)).then((res) => {
            if (res.payload.status === 200) {
                {
                    manageAddToast ? AppToast.Toast.success({ title: props?.actionToaster?.add?.title, message: props?.actionToaster?.add?.message })
                        : AppToast.Toast.success({ title: props?.actionToaster?.edit?.title, message: props?.actionToaster?.edit?.message })
                }
                setShowEditPopup(false);
                table_methods.refresh()
                dispatch(setChartDataEditted(!refreshChart))
            } else {
                AppToast.Toast.error({ title: 'Data Edited', message: 'Document Edit Failed.' })

            }
        })
    }

    function handleListingPopup(rowData){
        setRowData(rowData)
        setShowVersionListingPopup(true)
    }

    function RenderActions(rowData) {
        const testActionAgainstData_forEdit = (typeof (props?.testActionAgainstData?.edit) === 'function') ? props?.testActionAgainstData?.edit(rowData): undefined
        const testActionAgainstData_forDelete = (typeof (props?.testActionAgainstData?.delete) === 'function') ? props?.testActionAgainstData?.delete(rowData): undefined
        const testActionAgainstData_forPassReset = (typeof(props?.testActionAgainstData?.passwordReset) === 'function') ? props?.testActionAgainstData?.passwordReset(rowData): undefined

        
        const isPasswordReset = (testActionAgainstData_forPassReset !== undefined ? testActionAgainstData_forPassReset : true) && templateActions?.items?.find(x => x.name == "passwordReset") ? true : false;
        const isDelete = (testActionAgainstData_forDelete !== undefined ? testActionAgainstData_forDelete : true) && templateActions?.items?.find(x => x.name == "delete") ? true : false;
        const isDownload = templateActions?.items?.find(x => x.name == "download") ? true : false;
        const isEdit = (testActionAgainstData_forEdit !== undefined ? testActionAgainstData_forEdit : true) && templateActions?.items?.find(x => x.name === 'edit') ? true : false
        return <div className='action_icons'>
            {isDownload && <span className='download_icon' onClick={(event) => { handleActions(rowData, 'download', event); }}>
                {RenderIcons("download")}
            </span>}
           
            {permissions.Edit && isEdit && <span className='edit_icon' onClick={(event) => { handleActions(rowData, 'edit', event); }}>
                {RenderIcons("edit")}
            </span>}

            {permissions.Edit && isDelete && <span className='delete_icon' onClick={(event) => { handleActions(rowData, 'delete', event); }}>
                {RenderIcons("delete")}
            </span>}
            {permissions.FullControl && isPasswordReset && <span className='password_reset_icon' onClick={(event) => { handleActions(rowData, 'passwordReset', event); }}>
                {RenderIcons("passwordReset")}
            </span>}
            {!(isDelete && isDownload && isEdit) ? <>&nbsp;</> : ""}
        </div>
    };


    return (<>
        <Table
            fromPopup={props.fromPopup}
            parentId={props.parentId}
            dataType_id={props.dataType_id}
            deleteIcon={permissions.Edit ? true : false}
            paginator={props.paginator}
            rowsData={props.rowsData}
            rows={10}
            paginatorTemplate=" PrevPageLink PageLinks NextPageLink  CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={pagingDropDownInfo}
            defaultPageSize ={defaultPagingValue}
            filterDisplay="menu"
            responsiveLayout="scroll"
            emptyMessage="No results found."
            currentPageReportTemplate="Showing {first} - {last} of {totalRecords} results"
            _action={{ width: templateActions?.width, RenderAction: RenderActions }}
            templateName={props.templateName}
            onInit={(table_methods) => {
                setTable_methods(table_methods)
            }}
            multipleDelete={permissions.Edit ? true : false}
            handleMultipleDelete={(rows) => {
                setRowsToBeDeleted(rows)
                setShowDeletePopup(true);
            }}
            rowClass={props.rowClass}
            renderHeaderAreaRight={props.renderHeaderAreaRight}
            renderHeaderAreaLeft={props.renderHeaderAreaLeft}
            handleAddNewItem={handleAddNewItem}
            fields={controls}
            dataKey = {props.dataKey}
            setShowVersionListingPopup = {props.fromPopup ? null : handleListingPopup}
        />
        {showEditPopup && <UpdateListItemPopup
            fields={controls}
            setShowPopup={(val) => { setShowEditPopup(val) }}
            show={showEditPopup}
            row={rowData}
            title={currentActionInfo.title}
            actions={currentActionInfo.actions}
            onAddClick={handleEditData}
            key={rowData?._id}
        />}
        
        {showVersionListingPopup && <VersionListingPopup
            setShowPopup={(val) => { setShowVersionListingPopup(val) }}
            show={showVersionListingPopup}
            row={rowData}
            fields={controls}
            handleDownload={props.handleDownload}
        />}

        <ConformationPopup
            title={pageActionsInfo.delete.title}
            show={showDeletePopup}
            CancelButtonlabel={pageActionsInfo.delete.actions.cancel.label}
            SaveButtonlabel={pageActionsInfo.delete.actions.ok.label}
            handleCancel={() => setShowDeletePopup(false)}
            handleOk={() => {
                if (typeof props.handleDelete === "function")
                    props.handleDelete(rowsToBeDeleted, table_methods.refresh, setShowDeletePopup,)
                else
                    handleDelete(rowsToBeDeleted)

            }}
        >
            {pageActionsInfo.delete.message}
        </ConformationPopup>
    </>
    )
}
export default DataListing;